module.exports = __webpack_public_path__ + "chutti-bg.df7a1128050414add124.jpg";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/img/logo/chutti-bg.jpg
// module id = ../../../../../src/assets/img/logo/chutti-bg.jpg
// module chunks = main